
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Coins, AlertCircle } from 'lucide-react';

interface AnalysisCardBalanceProps {
  userBalance: number | null;
  canAfford: boolean;
  hasEnoughBalance: boolean;
}

export function AnalysisCardBalance({ userBalance, canAfford, hasEnoughBalance }: AnalysisCardBalanceProps) {
  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between text-sm">
        <span className="text-muted-foreground">Saldo atual:</span>
        <div className="flex items-center gap-1">
          <Coins className="h-4 w-4 text-yellow-500" />
          <span className={`font-medium ${hasEnoughBalance ? 'text-green-600' : canAfford ? 'text-orange-600' : 'text-red-600'}`}>
            {userBalance !== null ? `${userBalance} Seshs` : 'Carregando...'}
          </span>
        </div>
      </div>

      {!canAfford && userBalance !== null && (
        <Alert variant="destructive">
          <AlertCircle className="h-4 w-4" />
          <AlertDescription className="text-xs">
            Saldo insuficiente. Você precisa de {30 - userBalance} Seshs adicionais.
          </AlertDescription>
        </Alert>
      )}

      {canAfford && !hasEnoughBalance && (
        <Alert>
          <AlertCircle className="h-4 w-4" />
          <AlertDescription className="text-xs">
            Saldo baixo. Considere recarregar após esta análise.
          </AlertDescription>
        </Alert>
      )}
    </div>
  );
}
